/**
 * The two standing notices from COPY.md, verbatim.
 *
 * They live in their own module rather than in `components/common` so the public
 * pages (landing, legal) can render the footer without pulling the API client —
 * and therefore axios — into the first chunk an anonymous visitor downloads.
 */

/** COPY.md 상시 고지 — footer, every page. */
export const FOOTER_DISCLAIMER =
  "트랑슈는 투자자문업자 또는 투자일임업자가 아니며, 종목 추천이나 투자 조언을 제공하지 않아요. 서비스는 사용자가 직접 설정한 매매 규칙을 실행하는 도구이며, 투자 판단과 그 결과에 대한 책임은 전적으로 사용자 본인에게 있어요. 모든 투자에는 원금 손실의 위험이 따를 수 있어요.";

/** COPY.md 성과·실행 로그 표시 근처 고지 — required wherever returns appear. */
export const PERFORMANCE_DISCLAIMER =
  "위 실행 내역은 과거 실행 결과이며, 미래의 수익을 보장하지 않아요. 동일한 조건이라도 시장 상황에 따라 다른 결과가 나올 수 있어요.";
